import React, {useState} from 'react';

const Search = ({filter, dispatch, group, multiScreen}) => {
  const [searchValue, setSearchValue] = useState('');

  return (
    <div className="flex flex-col w-full gap-2">
      <label
        htmlFor={filter?.key}
        className={`${
          multiScreen ? 'text-sm' : 'text-md'
        } block text-md font-medium text-gray-700`}
      >
        Search For {filter?.title}
      </label>
      <div
        className={`${
          multiScreen ? 'px-1.5 py-0.5' : 'px-2 py-1'
        } border border-gray-300 rounded-md bg-white shadow-sm focus-within:ring-1 focus-within:ring-transparent focus-within:border-gray-300`}
      >
        <div className="mt-1">
          <input
            onChange={(e) => {
              dispatch({
                type: 'UPDATE_FILTER_VALUES',
                payload: {
                  updatedValue: e.target.value,
                  key: filter?.key,
                  minMax: null,
                  group,
                },
              });
              setSearchValue(e.target.value);
            }}
            type="text"
            name={filter?.key}
            id={filter?.key}
            className={`${
              multiScreen ? 'text-sm' : 'text-md'
            } block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 `}
            placeholder="AAPL"
            value={searchValue || ''}
          />
        </div>
      </div>
    </div>
  );
};

export default Search;
